import { render, staticRenderFns } from "./DbMapForm.vue?vue&type=template&id=92fbccea"
import script from "./DbMapForm.vue?vue&type=script&lang=js"
export * from "./DbMapForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports